import { deDE } from '@mui/x-date-pickers/locales';
import { de } from 'date-fns/locale';

// default locale if user not logged in
export const defaultLocale = de;
export const defaultLocaleText = deDE;
export const defaultLocaleFormatters = 'de-DE';
export const defaultCurrency = 'EUR';
